"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var framework_1 = require("../../widgets/framework");
var ForgotPasswordForm_1 = __importDefault(require("./components/ForgotPasswordForm"));
var styles_1 = __importDefault(require("./styles"));
var ForgotPasswordScreen = function () {
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_1.useState)(''), email = _a[0], setEmail = _a[1];
    var forgotPassSent = (0, react_redux_1.useSelector)(function (state) { return state.authentication.forgotPassSent; });
    var onNavigate = function () {
        var appNavigate = {
            action: 'LOGIN'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    return (react_1.default.createElement("div", { className: classes.forgotPasswordScreen },
        react_1.default.createElement(core_1.Grid, { className: classes.container, container: true, justifyContent: "center", item: true, xs: 12 },
            react_1.default.createElement(core_1.Grid, { sm: 10, md: 6 },
                react_1.default.createElement(core_1.Card, { className: classes.forgotPasswordCard },
                    react_1.default.createElement(core_1.CardContent, { className: classes.forgotPasswordCardContent },
                        react_1.default.createElement(core_1.Typography, { color: "primary", variant: "h2", className: classes.titleText }, t('forgotPassword.forgotPassword')),
                        !forgotPassSent && react_1.default.createElement(ForgotPasswordForm_1.default, { email: email, setEmail: setEmail }),
                        forgotPassSent && (react_1.default.createElement("div", { className: classes.content },
                            react_1.default.createElement("div", { className: classes.text },
                                react_1.default.createElement(core_1.Icon, { color: "primary", className: classes.mailIcon }, "mail")),
                            react_1.default.createElement("div", { className: classes.closeText },
                                react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body1" }, t('forgotPassword.instructionsSentTo'))),
                            react_1.default.createElement("div", { className: classes.text },
                                react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body1", style: { fontWeight: 'bold' } }, email)),
                            react_1.default.createElement("div", { className: classes.text },
                                react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body1" }, t('goTo'))),
                            react_1.default.createElement(core_1.Button, { className: classes.linkButton, onClick: onNavigate, size: "large", variant: "contained", color: "primary", "aria-label": "click here to go to login page" }, t('login.signIn'))))))))));
};
exports.default = ForgotPasswordScreen;
//# sourceMappingURL=index.js.map